import API from '@/api/'

export const isUsernameValid = (_, params) => {
  return API.user.availability(params).then(res => {
    const isValid = res.data.availability;
    return isValid;
  })
}

export const list = ({ commit, state }, params=null) => {
  const newParams = params ?? {max: state.max, offset: state.offset, sort: state.sort, order: state.order };
  //console.log(`action.organization.list: newParams = ${JSON.stringify(newParams)}`);
  return new Promise((resolve) => {
    API.user.list(newParams).then(res => {
      const {max, offset} = newParams;
      if (res.status === 200) {
        commit(`SET_LIST`, res.data[0]);
        commit(`SET_TOTAL`, res.data[1], );
        if (offset !== undefined) {
          commit(`SET_OFFSET`, offset, );
        }
        if (max !== undefined) {
          commit(`SET_MAX`, max, );
        }
        resolve(res)
      }
    })
  })
}

export const add = (_, params) => {
  delete params.checkPassword;
  return new Promise((resolve) => {
    API.user.add(params).then(res => {
      if (res.status === 201) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const update = (_, params) => {
  delete params.checkPassword;
  return new Promise((resolve) => {
    API.user.update(params).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const resetPwd = (_, params) => {
  delete params.checkPassword;
  return new Promise((resolve) => {
    API.user.resetPwd(params).then(res => {
      if (res.status === 201) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const remove = (_, params) => {
  return new Promise((resolve) => {
    API.user.remove(params).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const clear = ({ commit }) => {
  return new Promise((resolve) => {
    commit(`user/CLEAR`, {
      root: true
    });
    resolve();
  })
}
export default {
  isUsernameValid,
  list,
  add,
  update,
  remove,
  clear,
  resetPwd
};
